import { useQuery } from "@tanstack/react-query";
import { RoomInfo } from "../../types/chat";
import { chatApi } from "../../api/chat";

/**
 * Hook để tạo Azure Communication Services client từ room info
 * @param roomInfo - Thông tin phòng chat
 * @returns Query result với chatClient và chatThreadClient
 */
export const useClient = (roomInfo?: RoomInfo) => {
  const { Token, ThreadId } = roomInfo || {};

  return useQuery({
    queryKey: ["chat-client", ThreadId],
    queryFn: async () => chatApi.createClient(roomInfo!),
    enabled: !!Token && !!ThreadId,
    refetchOnMount: true,
    staleTime: Infinity, // Client không cần refetch
  });
};
